import React from 'react';
import { CheckCircleFilled } from '@ant-design/icons';

// Status-to-badge mapping shared across Admin Setup cards
export const getStatusBadge = (status) => {
  const statusMap = {
    completed: { text: 'Completed', color: 'success', icon: <CheckCircleFilled /> },
    incomplete: { text: 'Incomplete', color: 'warning', icon: <CheckCircleFilled /> },
    processing: { text: 'Processing', color: 'processing', icon: <CheckCircleFilled /> },
    empty: { text: 'Not Set', color: 'default', icon: null },
  };
  return statusMap[status] || statusMap.empty;
};
